/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import history from 'routes/history';
import { Context } from 'context/AuthContext';
import { GET_LIST_PAGED_RASCUNHO } from 'services/Rascunho';
import { Modal, Button } from 'react-bootstrap';
import TableList from './TableList';

import './styles.scss';

const ContentQuery = () => {
  const paramsLocation = new URLSearchParams(useLocation().search);

  const initialState = {
    pageNumber: paramsLocation.get('pageNumber') || 1,
    pageSize: paramsLocation.get('pageSize') || 25,
    list: [],
    pageData: {},
  };

  const { showLoader } = useContext(Context);
  const [model, setModel] = useState(initialState);
  const [refresh, setRefresh] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  useEffect(() => {
    history.listen((location) => {
      if (history.action === 'POP') {
        window.location = location.pathname + location.search;
      }
    });

    (async () => {
      showLoader(true);
      try {
        let params = getFilter();
        const data = await GET_LIST_PAGED_RASCUNHO(params);
        setModel((prev) => ({
          ...prev,
          pageData: data.value,
          list: data.value.data,
        }));
      } catch (error) {
        setModalMessage(
          error.response?.data?.message ||
            'Ocorreu um erro ao carregar os rascunhos.'
        );
        setShowModal(true);
      } finally {
        showLoader(false);
      }
    })();
  }, [refresh]);

  const getFilter = () => {
    return {
      pageNumber: model.pageNumber,
      pageSize: model.pageSize,
    };
  };

  const filterList = () => {
    let query = new URLSearchParams(getFilter()).toString();
    history.push({ pathname: '/rascunho', search: '?' + query });
    setRefresh(!refresh);
  };

  const handlePageChange = (pageNumber) => {
    setModel((prev) => ({ ...prev, pageNumber }));
    filterList();
  };

  return (
    <>
      <TableList
        model={model}
        onRefresh={filterList}
        handlePageChange={handlePageChange}
      />

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Atenção</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalMessage}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ContentQuery;